<template>
  <div>
    <Dialog
      :key="dialogKey"
      :visible.sync="showDialog1"
      :style="{ width: '80%', overflowY: 'auto' }"
      :header="'Customer Linked Accounts for ' + customer.custName"
      :modal="true"
      class="p-fluid"
    >
      <div style="min-height: 500px;" v-if="!accountDialog">
        <LinkedAccountsTable
          :accounts="linkedAccounts"
          :loading="loading"
          :removingLink="removingLink"
          @accountClicked="accountClicked"
          @removeLink="removeLink"
        />
      </div>
      <div style="min-height: 500px;" v-else>
        <!-- Account Form -->
        <AccountForm
          :accountDialog="accountDialog"
          :reload="realodAccountDialog"
          :refresh="refreshAccountDialog"
          :accountToEdit="account"
          :customer="customer"
          :disabledArr="disabledArr"
          requestType="customerMBPBranch"
          @close="closeAccountForm"
          @saved="savedAccount"
        />
      </div>

      <template #footer>
        <Button
          label="Okay"
          icon="pi pi-check"
          @click="$emit('close')"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import CustomerService from "@/service/CustomerService";

import LinkedAccountsTable from "./LinkedAccountsTable";
import AccountForm from "./AccountForm";

export default {
  components: {
    LinkedAccountsTable,
    AccountForm
  },
  created() {
    this.setupComponent();
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    reloadDialog: {
      type: Number,
      required: false
    },
    customer: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    customerService: new CustomerService(),
    dialogKey1: 0,
    requesting: false,
    linkedAccounts: [],
    accountDialog: false,
    realodAccountDialog: 0,
    refreshAccountDialog: 0,
    account: {},
    disabledArr: [],
    removingLink: {},
    activeButtonClicked: false
  }),
  computed: {
    loading() {
      if (this.linkedAccounts && this.linkedAccounts[0]) {
        return false;
      } else {
        if (this.requesting) {
          return true;
        } else {
          return false;
        }
      }
    },
    dialogKey: {
      set() {
        this.dialogKey1++;
      },
      get() {
        return "dialogKey-" + this.dialogKey1.toString();
      }
    },
    showDialog1: {
      set(val) {
        if (!val) {
          this.$emit("close");
        }
      },
      get() {
        return this.showDialog;
      }
    }
  },
  watch: {
    linkedAccounts(val) {},
    reloadDialog() {
      this.dialogKey = this.dialogKey1 + 1;
      this.setupComponent();
    }
  },
  methods: {
    removeLink(account) {
      if (!account.mainBranch) {
        if (account.customerId && account.branchId) {
          this.removingLink = account;

          this.customerService
            .removeLink(account.customerId, account.branchId)
            .then(data => {
              this.removingLink = {};
              this.assignedCustomerMBPbranches();
            })
            .catch(error => {
              this.removingLink = {};
              let index = -1,
                a = "java.lang.RuntimeException: ";
              if (error.response.data) {
                index = error.response.data.indexOf(a);
              }
              if (index < 0) {
                this.$store.dispatch("addErrorMessage", {
                  severity: "error",
                  content:
                    'Some data was not loaded from "unlinkBranch/{customerId}{branchId}"'
                });
              } else {
                this.$toast.add({
                  severity: "error",
                  summary: "Error Message",
                  detail: error.response.data.substr(
                    index + a.length,
                    error.response.data.length - 1
                  ),
                  life: 5000
                });
              }
            });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Data representation undefined!",
            life: 5000
          });
        }
      } else {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail:
            "You can't remove a main Branch. Set a different main Branch first.",
          life: 5000
        });
      }
    },
    reverseAcountActive() {
      let index = this.linkedAccounts.findIndex(
        a => a.branchCode === this.account.branchCode
      );
      if (!this.linkedAccounts[index].mainBranch && this.activeButtonClicked) {
        this.linkedAccounts[index].active = !this.linkedAccounts[index].active;
      }
      //
    },
    closeAccountForm() {
      this.accountDialog = false;
      // this.reverseAcountActive()
    },
    savedAccount(account) {
      this.assignedCustomerMBPbranches();
      this.accountDialog = false;
    },
    accountClicked(account) {
      if (account.data) {
        this.activeButtonClicked = false;
        this.account = account.data;
      } else {
        this.activeButtonClicked = true;
        this.account = account;
      }

      if (this.account) {
        if (this.account.mainBranch) {
          this.disabledArr = ["mbpBranch", "mainBranch", "active"];
        } else {
          this.disabledArr = ["mbpBranch"];
        }
        this.accountDialog = true;
        this.refreshAccountDialog++;
        this.realodAccountDialog++;
      }
    },
    setupComponent() {
      //
      this.removingLink = {};
      this.assignedCustomerMBPbranches();
    },
    assignedCustomerMBPbranches() {
      if (this.customer && this.customer.customerId) {
        this.requesting = true;
        this.linkedAccounts = [];

        this.customerService
          .assignedCustomerMBPbranches(this.customer.customerId)
          .then(data => {
            this.requesting = false;

            this.linkedAccounts = data;
          })
          .catch(error => {
            this.requesting = false;

            this.$store.dispatch("addErrorMessage", {
              severity: "error",
              content:
                'Some data was not loaded from "assignedCustomerMBPbranches/{customerId}"'
            });
          });
      }
    }
  }
};
</script>

<style></style>
